import { useState, useContext } from 'react';

import endpoints from '../../../../../../../../../api/endpoints';
import { BusinessError } from '../../../../../../../../common/business-error';
import { handleResponseError } from '../../../../../../../../../api/handleResponseError';
import { ToastNotificationContext } from '../../../../../../../../common/toast-notification';
import { addParams, fetchWithTokenRefresh } from '../../../../../../../../../api/fetchWithTokenRefresh';

import { getLowBalanceNotificationSettingsUpdateBusinessError } from '../businessErrors';

type DialogError = BusinessError | null;

export const useSettingsUpdate = () => {
  const [lowBalanceNotificationLoading, setLoading] = useState<boolean>(false);
  const [lowBalanceNotificationError, setError] = useState<DialogError>(null);
  const { openToast } = useContext(ToastNotificationContext);

  const handleSettingsUpdate = async (settings: any, onSuccess: () => void) => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetchWithTokenRefresh(endpoints.clientLowBalance, addParams('PUT', settings));

      if (response.status !== 204) {
        await handleResponseError(response);
      }

      openToast({
        message: 'Low balance notification settings updated successfully',
        severity: 'success'
      });

      onSuccess();
      setLoading(false);
    } catch (e) {
      const { message, severity } = getLowBalanceNotificationSettingsUpdateBusinessError();

      setError({ message, severity });
      setLoading(false);
    }
  };

  return { lowBalanceNotificationError, lowBalanceNotificationLoading, handleSettingsUpdate };
};
